export const EmbroideryPermissions = {
  "General Manager": [],
  "Asst. General Manager": [],
  Manager: [
    {
      path: "/embroidery/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/embroidery/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  Designer: [],
  "Assistant Manager": [],
  Incharge: [
    {
      path: "/embroidery/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/embroidery/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],
  "Embroidery Incharge": [
    {
      path: "/embroidery/receives",
      label: "Receives",
      icon: "fas fa-chevron-right me-1",
    },
    {
      path: "/embroidery/returns",
      label: "Returns",
      icon: "fas fa-chevron-right me-1",
    },
  ],

  Executive: [],
  "Jr. Executive": [],
  "Sr. Executive": [],
};
